



































import { Vue, Component, Prop } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import moment from "moment";
import { postCustomerServiceNote, getCustomerServiceNotes } from "@/lib/api";
import { User } from "@/types";
import logger from "@/configs/logger";
import { collections, firestore } from "@/configs/firebase";

@Component
export default class LeadNotes extends Vue {
  @Prop({ required: true }) lead!: any;
  @Action("addLeadNote") addLeadNote!: Function;
  @Action("getLeadNotes") getLeadNotes!: Function;
  @State("user") user!: User;

  newNote: string = "";
  notes: any[] = [];
  loadingNotes = false;

  created() {
    this.getNotes();
  }

  handleEnter(e: KeyboardEvent) {
    if (e.code !== "Enter") return;
    this.newNote && this.handleAddNote(true);
  }

  async handleAddNote(clear = false) {
    try {
      this.loadingNotes = true;
      const newNote = {
        leadId: this.lead.id,
        note: this.newNote,
        user_email: this.user.email,
        created_ts: firestore.Timestamp.now()
      };
      const ref = collections.customerServiceNotes
        .doc(this.lead.id)
        .collection("notes")
        .doc();
      await ref.set(newNote);
      this.notes = [...this.notes, { id: ref.id, ...newNote }];
      if (clear) this.newNote = "";
    } catch (err) {
      logger("error", "add customer service note error:", err);
    } finally {
      this.loadingNotes = false;
    }
  }

  async getNotes() {
    try {
      this.loadingNotes = true;
      const snapshot = await collections.customerServiceNotes
        .doc(this.lead.id)
        .collection("notes")
        .orderBy("created_ts", "desc")
        .get();
      this.notes = snapshot.docs.map(doc => doc.data());
    } catch (err) {
      logger("error", "get customer service notes error");
    } finally {
      this.loadingNotes = false;
    }
  }

  formatTime(ts: number) {
    return moment.unix(ts).fromNow();
  }
}
